import React from 'react';
import ResourceNotFound from './ResourceNotFound';

export default () => <ResourceNotFound message="Sorry but we couldn't find this order." />;
